import classNames from "classnames"
import { values } from "lodash"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import { htmlType } from "../../constants/index.es6"

import styles from "./html.less"

class Html extends C {
  render() {
    const {
      ariaRowIndex,
      id,
      children,
      className,
      dataQa,
      dataTitle,
      dataSortableHandlerId,
      dataSortableId,
      dataSortableLimited,
      dataSortableParentId,
      dataSortableType,
      type,
      ...rest
    } = this.props

    switch (type) {
      case htmlType.table:
        return (
          <tr
            ref={(element) => (this._element = element)}
            className={classNames("on-check-ignore-row-select", className)}
            data-sortable-id={dataSortableId}
            data-sortable-limited={dataSortableLimited}
            data-sortable-handler-id={dataSortableHandlerId}
            data-sortable-type={dataSortableType}
            data-sortable-parent-id={dataSortableParentId}
            data-qa={dataQa}
            data-title={dataTitle}
            aria-rowindex={`${ariaRowIndex}`}
            id={id}
            {...rest}>
            {children}
          </tr>
        )

      case htmlType.div:
        return (
          <div
            role="row"
            // tabIndex={0}
            ref={(element) => (this._element = element)}
            className={classNames("on-check-ignore-row-select", styles.div, className)}
            data-sortable-id={dataSortableId}
            data-sortable-limited={dataSortableLimited}
            data-sortable-handler-id={dataSortableHandlerId}
            data-sortable-type={dataSortableType}
            data-qa={dataQa}
            data-title={dataTitle}
            aria-rowindex={`${ariaRowIndex}`}
            id={id}
            {...rest}>
            {children}
          </div>
        )

      default:
        throw Error(`Type "${type}" not supported`)
    }
  }
}

Html.propTypes = {
  type: PropTypes.oneOf(values(htmlType)),
  className: PropTypes.string,
  onMouseDown: PropTypes.func,
  onTouchStart: PropTypes.func,
  style: PropTypes.object,
  dataSortableId: PropTypes.string,
  dataSortableHandlerId: PropTypes.string,
  dataSortableType: PropTypes.string,
  dataSortableParentId: PropTypes.string,
  dataSortableLimited: PropTypes.string,
}

Html.defaultProps = {
  type: htmlType.div,
}

export default Html
